const SEEN_ANNOUNCEMENTS_KEY = 'vdex_seen_announcements'
const NOTIFICATION_DISMISSED_KEY = 'vdex_notification_dismissed'

export interface SeenAnnouncementStorage {
    announcementIds: string[]
    lastUpdated: string
}

export const getSeenAnnouncementIds = (): string[] => {
    try {
        const stored = localStorage.getItem(SEEN_ANNOUNCEMENTS_KEY)
        if (!stored) return []

        const parsed: SeenAnnouncementStorage = JSON.parse(stored)
        return parsed.announcementIds || []
    } catch (error) {
        console.error('Error reading seen announcements from localStorage:', error)
        return []
    }
}

export const markAnnouncementAsSeen = (announcementId: string): void => {
    try {
        const currentIds = getSeenAnnouncementIds()
        if (currentIds.includes(announcementId)) return

        const updatedStorage: SeenAnnouncementStorage = {
            announcementIds: [...currentIds, announcementId],
            lastUpdated: new Date().toISOString()
        }

        localStorage.setItem(SEEN_ANNOUNCEMENTS_KEY, JSON.stringify(updatedStorage))

        // Dispatch custom event to notify listeners about the change
        window.dispatchEvent(new CustomEvent('vdex-announcements-updated'))
    } catch (error) {
        console.error('Error saving seen announcement to localStorage:', error)
    }
}

export const markMultipleAnnouncementsAsSeen = (announcementIds: string[]): void => {
    try {
        const currentIds = getSeenAnnouncementIds()
        const newIds = announcementIds.filter(id => !currentIds.includes(id))

        if (newIds.length === 0) return

        const updatedStorage: SeenAnnouncementStorage = {
            announcementIds: [...currentIds, ...newIds],
            lastUpdated: new Date().toISOString()
        }

        localStorage.setItem(SEEN_ANNOUNCEMENTS_KEY, JSON.stringify(updatedStorage))

        // Dispatch custom event to notify listeners about the change
        window.dispatchEvent(new CustomEvent('vdex-announcements-updated'))
    } catch (error) {
        console.error('Error saving multiple seen announcements to localStorage:', error)
    }
}

export const isNotificationDismissed = (): boolean => {
    try {
        const dismissed = localStorage.getItem(NOTIFICATION_DISMISSED_KEY)
        return dismissed === 'true'
    } catch (error) {
        console.error('Error reading notification dismissed state:', error)
        return false
    }
}

export const setNotificationDismissed = (dismissed: boolean): void => {
    try {
        localStorage.setItem(NOTIFICATION_DISMISSED_KEY, dismissed.toString())
    } catch (error) {
        console.error('Error saving notification dismissed state:', error)
    }
}

export const clearNotificationDismissed = (): void => {
    try {
        localStorage.removeItem(NOTIFICATION_DISMISSED_KEY)
    } catch (error) {
        console.error('Error clearing notification dismissed state:', error)
    }
} 